import React, {Component, forwardRef, useImperativeHandle} from 'react';
import axios from 'axios';
import PersonRounded from '@material-ui/icons/PersonRounded';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {Button} from "@material-ui/core";
import Form from "react-bootstrap/Form";
import {motion} from "framer-motion"
import classes from './EditUser.module.css';
import GroupsInput from "./GroupsInput/GroupsInput";
import apiUrl from "../../shared/config";
import Select from "react-select";
import Spinner from "react-bootstrap/Spinner";
import AutoLoadToggle from "../AutoLoadToggle/AutoLoadToggle";
import * as actionTypes from '../../store/actions/actionTypes';
import { connect } from 'react-redux';
import {getDisplayName} from "../../utils/utils";


class EditUser extends Component {
    constructor(props) {
        super(props);
        this._isMounted = false; // Initialize a unique instance variable
    }

    state = {
        "account_id": this.props.account_id || null,
        "user_id": this.props.user_id || null,
        "enable_notifications": 0,
        "first_name": "",
        "last_name": "",
        "display_name": "",
        "user_contact_email": "",
        "share_contact_email": 0,
        "email_frequency": 'daily',
        "groups": [],
        "email_frequencies": [
           {value: 0, label: 'Daily', color: '#9999FF'},
          {value: 1, label: 'Weekly', color: '#9999FF'},
        {value: 2, label: 'Monthly', color: '#9999FF'}],
        "initial_user_contact_email": "",
        "initial_share_contact_email": 0,
        "auto_load_game_demos": 0,
        "loading": true,
    };


    componentDidMount() {
        this._isMounted = true
        if (this.props.account_id ) {
            const token = localStorage.getItem('token');
            const config = {
                headers: { Authorization: `Bearer ${token}` },
                params: {
                    account_id: this.props.account_id
                }
            };
            axios.get(apiUrl +'Users/getUserByAccountId?token=' + this.props.token, config)
                .then(response => {
                    if (response.data.account_id !== null && this._isMounted) {
                        this.setState({
                            "account_id": response.data.account_id,
                            "user_id": response.data.user_id,
                            "enable_notifications": response.data.enable_notifications,
                            "first_name": response.data.first_name ? response.data.first_name : "",
                            "last_name": response.data.last_name ? response.data.last_name : "",
                            "display_name": response.data.display_name ? response.data.display_name : "",
                            "user_contact_email": response.data.user_contact_email ? response.data.user_contact_email : "",
                            "share_contact_email": response.data.share_contact_email ? response.data.share_contact_email : 0,
                            "email_frequency": response.data.email_frequency ? response.data.email_frequency : "weekly",
                            "groups": response.data.groups ? response.data.groups : [],
                            "initial_user_contact_email": response.data.user_contact_email ? response.data.user_contact_email : "",
                            "initial_share_contact_email": response.data.share_contact_email ? response.data.share_contact_email : 0,
                            "auto_load_game_demos": response.data.auto_load_game_demos ? response.data.auto_load_game_demos : 0,
                            "loading": false,
                        });
                    }
                });
        }
        else if (this.props.account_id === null && this._isMounted) {
            this.setState({
                    "account_id": this.props.account_id,
                    "user_id": null,
                    "enable_notifications": 0,
                    "first_name": "",
                    "last_name": "",
                    "display_name": "",
                    "user_contact_email": "",
                    "share_contact_email": 0,
                    "auto_load_game_demos": 0,
                    "email_frequency": "weekly",
                    "groups": []
            });
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setAutoLoadHandler = (val) => {
        this.props.setAutoLoadGameDemos(val);

        let prefs = localStorage.getItem('user_preferences');
        // check local storage since it is used to set this redux state on login.
        if (prefs) {
            prefs = JSON.parse(prefs);
            prefs.auto_load_game_demos = val;
            localStorage.setItem('user_preferences', JSON.stringify(prefs));
        } else {
            // If preferences don't exist, create a new entry
            const newPrefs = {
                auto_load_game_demos: val
            };
            localStorage.setItem('user_preferences', JSON.stringify(newPrefs));
        }
    };

    postDataHandler = (user_id) => {
        const post = {
            "account_id": this.props.account_id,
            "user_id": user_id,
            "enable_notifications": this.state.enable_notifications,
            "first_name": this.state.first_name,
            "last_name": this.state.last_name,
            "display_name": this.state.display_name,
            "user_contact_email": this.state.user_contact_email,
            "share_contact_email": this.state.share_contact_email,
            "email_frequency": this.state.email_frequency,
            "groups": this.state.groups,
            "auto_load_game_demos": this.state.auto_load_game_demos,
        };

        this.setState({"loading": true,});
        axios.post(apiUrl +'Users/set?token=' + this.props.token, post)
            .then(() => this.setAutoLoadHandler(this.state.auto_load_game_demos))
            .then(response => {
                let temp_id = user_id;
                if (response.data.user_id && response.data.user_id !== user_id) {
                    temp_id = response.data.user_id;
                }
                this.props.submitEditUser(temp_id);
            }).then(() => this.setState({
                "account_id": this.state.account_id,
                "user_id": null,
                "enable_notifications": 0,
                "first_name": "",
                "last_name": "",
                "display_name": "",
                "user_contact_email": "",
                "groups": [],
                "initial_user_contact_email": "",
                "initial_share_contact_email": 0,
                "auto_load_game_demos": 0,
                "loading": true,
            })).then(() => this.props.closeEditUser()
            ).catch(() => this.props.closeEditUser());

    };

    addHandler = () => {
        this.postDataHandler(null);
    };

    updateHandler = () => {
        this.postDataHandler(this.props.user_id);
    };

    groupsUpdateHandler = (new_value) => {
        this.setState({groups: new_value});
    };

    emailFrequencyToIndex = (email_frequency) => {
        switch (email_frequency) {
            case 'daily':
                return 0
            case 'weekly':
                return 1
            case 'monthly':
                return 2
            default:
                return 1
        }
    }

    render() {
        let display_warning = (this.state.initial_user_contact_email && this.state.initial_share_contact_email
            && (!this.state.user_contact_email || !this.state.share_contact_email))
        let display_comment_info = ((!this.state.initial_user_contact_email || !this.state.initial_share_contact_email)
            && (!this.state.user_contact_email || !this.state.share_contact_email) && this.state.user_id)
        let addAndUpdateButton = (<Button onClick={this.addHandler}>Submit User Details</Button>);
        let pageTitle = "Enter User Details";
        if (this.state.user_id !== null) {
            addAndUpdateButton = (<Button onClick={this.updateHandler}>Update User Details</Button>);
            pageTitle = (<>Editing:  <PersonRounded style={{fontSize: 30, marginBottom: 4}}/>
                {getDisplayName(this.state.display_name, this.state.first_name, this.state.last_name)}</>);
        }

        const user_jsx = (<div className="row">
            First Name
            <Form.Control
                type="text"
                placeholder="Enter Your First Name."
                value={this.state.first_name}
                onChange={(event) => this.setState({first_name: event.target.value})}
            />
            Last Name
            <Form.Control
                type="text"
                placeholder="Enter Your Last Name."
                value={this.state.last_name}
                onChange={(event) => this.setState({last_name: event.target.value})}
            />
            Display Name
            <Form.Control
                type="text"
                placeholder="Enter a Display Name."
                value={this.state.display_name}
                onChange={(event) => this.setState({display_name: event.target.value})}
            />
            Contact Email
            <Form.Control
                type="text"
                placeholder="Enter the email address you want to share."
                value={this.state.user_contact_email}
                onChange={(event) => {
                    this.setState({user_contact_email: event.target.value})
                }}
            />
            <span style={{display:"flex"}}>
                <FormControlLabel
                    control={
                        <Checkbox
                            disableRipple
                            style={{paddingBottom: 0, paddingTop: 0}}
                            checked={(!!this.state.share_contact_email)}
                            onChange={(event) => {
                                this.setState({share_contact_email: (this.state.share_contact_email === 1 ? 0 : 1)})
                            }}
                            name="share_contact_email"
                            color="primary"
                        />
                    }
                    label="Display Contact Email"
                    style={{marginBottom: 0, paddingTop: 5}}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            disableRipple
                            style={{paddingBottom: 0, paddingTop: 0}}
                            checked={(!!this.state.enable_notifications)}
                            onChange={(event) => this.setState({enable_notifications: (this.state.enable_notifications === 1 ? 0 : 1)})}
                            name="enable_notifications"
                            color="primary"
                        />
                    }
                    label="Enable Notifications"
                    style={{marginBottom: 0, paddingTop: 5}}
                />
                <AutoLoadToggle toggleType={"checkbox"} checkboxState={this.state.auto_load_game_demos}
                                handleCheckboxChange={() => this.setState({auto_load_game_demos: this.state.auto_load_game_demos === 1 ? 0 : 1})}/>
            </span>
            {this.state.enable_notifications ? <div
                style={{  //minWidth: 200,
                width: "100%",
                // margin: "0 auto",
                // textAlign: "left",
            }}
            >
                <div //style={{fontWeight: "bold",paddingBottom: 2}}
                >Email Frequency</div>
                <Select
                    isSingle
                    options={this.state.email_frequencies}
                    defaultValue={this.state.email_frequencies[this.emailFrequencyToIndex(this.state.email_frequency)]}
                    closeMenuOnSelect={true}
                    placeholder="Select how often you would like to recieve update emails"
                    onChange={(val) => {
                       this.setState({email_frequency: val.label.toLowerCase()});
                    }}
                /></div> : ""
            }
            {display_warning
                ? <span className="remove-email-warning">
                    WARNING: If you update your account, you will no longer have a visible contact email.
                    You won't be able to make contributions under patterns, and any contributions you previously made will be
                    hidden until you provide a visible contact email. Any patterns where you are the only author with
                    a visible contact email will be hidden, as well.
                </span>
                : ""}
            {display_comment_info
                ? <span className="remove-email-warning" style={{color: "blue"}}>
                    To add contributions under other users' patterns, enter and display your contact email. Only users with
                    a visible contact email can make contributions on other users' patterns.
                </span>
                : ""}
        </div>);

        const edit_groups_jsx = (
            <GroupsInput
                groups={this.state.groups}
                groupsUpdate={(val) => this.groupsUpdateHandler(val)}
            />
        );

        return (
            this.state.loading ? <Spinner animation={"border"}/> :
            <motion.div initial={{scale: 0}} animate={{scale: 1}} transition={{duration: .4 }} className={'card '+ classes.UserCard}>
                <h4 className="card-header">{pageTitle}</h4>
                <div className="card-body">
                    <div className="cardText">
                        {user_jsx}
                        <br/>
                        {edit_groups_jsx}
                        {!this.props.useNew && (
                            <>
                                {addAndUpdateButton}
                                <Button onClick={this.props.closeEditUser}>Cancel</Button>
                            </>
                        )}
                    </div>
                </div>
            </motion.div>
        );
    }
}


const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
    setAutoLoadGameDemos: (val) => dispatch({type: actionTypes.UPDATE_AUTO_LOAD_GAME_EMBEDS, value: val}), // Map dispatch actions
});


const ConnectedEditUser = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(EditUser);


const EditUserWithRef = forwardRef((props, ref) => {
    const editUserRef = React.useRef();

    // Expose updateHandler via ref
    useImperativeHandle(ref, () => ({
        updateHandler: editUserRef.current.updateHandler,
    }));

    return <ConnectedEditUser {...props} ref={editUserRef} />;
});

export default EditUserWithRef;